import api from "../../utils/axios-util";
import Middleware from "../../utils/api-middleware"

export const Message = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/message`, payload)
                .then((response) => {
                    let res = Middleware("Message", "create", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("Message", "create", err.response.data, "catch")
                    reject(res);
                });
        });
    }

};